<template>
  <v-card>
    <v-card-title>
      Organizátori ({{ count }})

      <v-spacer/>

      <Create
          :icon="true"
          @init="init"
      />

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          :loading="loading"
          :disabled="loading"
          color="default"
          @click="init"
      >
        <v-icon>
          mdi-refresh
        </v-icon>
      </v-btn>

      &nbsp;

      <v-btn
          :icon="true"
          :outlined="true"
          color="default"
          @click="downloadFileByLink(loadLinkByPath('app/organizers/export'))"
      >
        <v-icon>
          mdi-download
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <v-expansion-panels
              v-model="expansionPanelsFilter"
              :multiple="true"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <span>
                  <v-icon
                      color="info"
                  >
                    mdi-filter
                  </v-icon>

                  Filtre
                </span>
              </v-expansion-panel-header>

              <v-expansion-panel-content>
                <v-row>
                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.billingName"
                        :error-messages="errors.Filters && errors.Filters.billingNamename"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Spoločnosť"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.name"
                        :error-messages="errors.Filters && errors.Filters.name"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Priezvisko & Meno"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.email"
                        :error-messages="errors.Filters && errors.Filters.email"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="E-mail"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>

                  <v-col
                      cols="12"
                      lg="3"
                  >
                    <v-text-field
                        v-model="params.Filters.phone"
                        :error-messages="errors.Filters && errors.Filters.phone"
                        :outlined="true"
                        :dense="true"
                        hide-details="auto"
                        label="Telefón"
                        :clearable="true"
                        @change="setFilter"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row>
        <v-col
            cols="12"
        >
          <v-card>
            <v-card-text>
              <v-progress-linear
                  v-if="loading"
                  :indeterminate="true"
              />

              <v-simple-table>
                <template
                    v-slot:default
                >
                  <thead>
                    <tr>
                      <th>
                        Logo
                      </th>

                      <th
                          class="fixed"
                      >
                        <a
                            @click="setOrder($store.state.register.Organizer.Filter.order['billingName'].value)"
                        >
                          <template
                              v-if="params.order === $store.state.register.Organizer.Filter.order['billingName'].value"
                          >
                            <template
                                v-if="params.by === $store.state.register.Organizer.Filter.by['ASC'].value"
                            >
                              <v-icon>
                                mdi-chevron-up
                              </v-icon>
                            </template>

                            <template
                                v-else
                            >
                              <v-icon>
                                mdi-chevron-down
                              </v-icon>
                            </template>
                          </template>

                          Spoločnosť
                        </a>
                      </th>

                      <th>
                        Fotografia
                      </th>

                      <th>
                        Priezvisko & Meno
                      </th>

                      <th>
                        E-mail
                      </th>

                      <th>
                        Telefón
                      </th>

                      <th
                          class="text-right fixed"
                      />
                    </tr>
                  </thead>

                  <tbody>
                    <template
                        v-if="organizers.length > 0"
                    >
                      <tr
                          v-for="Organizer in organizers"
                          :key="Organizer.id"
                      >
                        <td>
                          <silent-box
                              v-if="Organizer.Logo"
                              :image="{
                                  src: loadLinkByPath('files/generate/image/original/' + Organizer.Logo.token)
                              }"
                          >
                            <template
                                v-slot:silentbox-item
                            >
                              <v-img
                                  :src="loadLinkByPath('files/generate/image/thumbnail/36/36/' + Organizer.Logo.token)"
                                  alt="Obrázok"
                                  max-width="36px"
                              />
                            </template>
                          </silent-box>

                          <template
                              v-else
                          >
                            <v-icon
                                color="error"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                        </td>

                        <td
                            class="fixed"
                        >
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Organizer.billingName }}
                          </span>
                        </td>

                        <td>
                          <silent-box
                              v-if="Organizer.Photo"
                              :image="{
                                  src: loadLinkByPath('files/generate/image/original/' + Organizer.Photo.token)
                              }"
                          >
                            <template
                                v-slot:silentbox-item
                            >
                              <v-img
                                  :src="loadLinkByPath('files/generate/image/thumbnail/36/36/' + Organizer.Photo.token)"
                                  alt="Obrázok"
                                  max-width="36px"
                              />
                            </template>
                          </silent-box>

                          <template
                              v-else
                          >
                            <v-icon
                                color="error"
                            >
                              mdi-close
                            </v-icon>
                          </template>
                        </td>

                        <td>
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Organizer.name }}
                          </span>
                        </td>

                        <td>
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Organizer.email }}
                          </span>
                        </td>

                        <td>
                          <span
                              class="text-truncate"
                              style="max-width: 300px"
                          >
                            {{ Organizer.phone }}
                          </span>
                        </td>

                        <td
                            class="text-right fixed"
                        >
                          <Update
                              :icon="true"
                              :id="Organizer.id"
                              @init="init"
                          />

                          &nbsp;

                          <Delete
                              :icon="true"
                              :id="Organizer.id"
                              @init="init"
                          />
                        </td>
                      </tr>
                    </template>

                    <template
                        v-else
                    >
                      <tr>
                        <td
                            :colspan="7"
                            class="text-center"
                        >
                          Nenašli sa žiadni organizátori.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </template>
              </v-simple-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row
          v-if="pages !== 0"
          align="center"
      >
        <v-col
            cols="4"
        >
          <a
              v-for="(limit, i) in $store.getters['register/getOrganizerFilterLimit']"
              :key="i"
              @click="setLimit(limit.value)"
          >
            {{ limit.text }}
          </a>
        </v-col>

        <v-spacer/>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === 1 || loading"
              color="primary"
              @click="previousPage"
          >
            <v-icon>
              mdi-chevron-left
            </v-icon>
          </v-btn>
        </v-col>

        <v-col
            cols="auto"
        >
          {{ params.page }} / {{ pages }}
        </v-col>

        <v-col
            cols="auto"
        >
          <v-btn
              :icon="true"
              :outlined="true"
              :loading="loading"
              :disabled="params.page === pages || loading"
              color="primary"
              @click="nextPage"
          >
            <v-icon>
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  import Qs from 'qs'
  import QueryTypes from 'query-types'

  import Organizers from '@/services/organizers'

  import Create from '@/components/Organizers/Create'
  import Update from '@/components/Organizers/Update'
  import Delete from '@/components/Organizers/Delete'

  export default {
    name: 'Organizers',
    components: {
      Create,
      Update,
      Delete
    },
    data() {
      return {
        expansionPanelsFilter: [],
        loading: false,
        count: 0,
        pages: 1,
        organizers: [],
        params: {
          Filters: {
            billingName: '',
            name: '',
            email: '',
            phone: ''
          },
          order: this.$store.state.register.Organizer.Filter.order['billingName'].value,
          by: this.$store.state.register.Organizer.Filter.by['ASC'].value,
          limit: this.$store.state.register.Organizer.Filter.limit[25].value,
          page: 1
        },
        errors: {}
      }
    },
    metaInfo() {
      return {
        title: 'Organizátori'
      }
    },
    beforeMount() {
      this.beforeInit()
    },
    mounted() {
      this.init()
    },
    methods: {
      beforeInit() {
        this.params = {
          ...this.params,
          ...Qs.parse(QueryTypes.parseObject(this.$route.query))
        }
      },
      init() {
        this.loadData()
      },
      setFilter() {
        this.params.page = 1

        this.init()
      },
      setOrder(order) {
        this.params.order = order

        switch (this.params.by) {
          case this.$store.state.register.Organizer.Filter.by['ASC'].value:
            this.params.by = this.$store.state.register.Organizer.Filter.by['DESC'].value

            break

          case this.$store.state.register.Organizer.Filter.by['DESC'].value:
            this.params.by = this.$store.state.register.Organizer.Filter.by['ASC'].value

            break
        }

        this.params.page = 1

        this.init()
      },
      setLimit(limit) {
        this.params.limit = limit

        this.params.page = 1

        this.init()
      },
      previousPage() {
        this.params.page -= 1

        window.scrollTo(0, 0)

        this.init()
      },
      nextPage() {
        this.params.page += 1

        window.scrollTo(0, 0)

        this.init()
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Organizátori',
              to: '/organizers'
            }
          ]
        })
      },
      loadData() {
        this.setBreadcrumbs()

        this.loading = true

        this.$router.replace('?' + Qs.stringify(this.params))

        Organizers
          .index({
            params: this.params
          })
          .then((response) => {
            this.count = response.data.data.count

            this.pages = response.data.data.pages

            this.organizers = response.data.data.organizers

            this.errors = {}
          })
          .catch((error) => {
            switch (error.response.status) {
              case 400:
                this.errors = error.response.data.errors

                break

              case 401:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                break
            }
          })
          .finally(() => {
            this.loading = false
          })
      },
      loadLinkByPath(path) {
        return process.env.VUE_APP_AXIOS_URL + path
      },
      downloadFileByLink(link) {
        window.open(link)
      }
    }
  }
</script>
